import { render } from "./Simple.vue?vue&type=template&id=d38498f4"
import script from "./Simple.vue?vue&type=script&lang=js"
export * from "./Simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/PageFooter/Simple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d38498f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d38498f4', __exports__)) {
    api.reload('d38498f4', __exports__)
  }
  
  module.hot.accept("./Simple.vue?vue&type=template&id=d38498f4", () => {
    api.rerender('d38498f4', render)
  })

}


export default __exports__